import React, { useEffect, useState } from 'react';
import './App.css';
import {BrowserRouter as Router, Route, Routes, Link, Navigate } from 'react-router-dom';
import { ColorSchemeProvider, MantineProvider } from '@mantine/core';
import {
    RecoilRoot,
  } from 'recoil';
import PrivateRoutes from './utils/PrivateRoutes';
import AdminPrivateRoute from './utils/AdminPrivateRoute';
import ReportPage from './pages/ReportPage';
import MachinePage from './pages/MachinePage';
import TrailPage from './pages/TrailPage';
import DashBoardPage from './pages/DashBoardPage';
import Home from './components/home/Home';
import PageNotFound404 from './pages/PageNotFound404';
import LoginPage from './pages/LoginPage';
import PdfExport from './components/PdfExports/PdfExport';
import AlarmCard from './components/cards/AlarmCard';
import SubMachine from './pages/SubMachine';
import AdminPanel from './pages/AdminPanel';
import SuperAdminPanel from './pages/superadmin/SuperAdminPanel';
import MachineEditPage from './pages/admin/MachineEditPage';
import UserEditPage from './pages/admin/UserEditPage';



function App() {

 
 
  const [colorScheme, setColorScheme] = useState('light')
  const toggleColorScheme = (value) => setColorScheme(value || (colorScheme === 'dark' ? 'light' : 'dark'))
  
  return (
    <ColorSchemeProvider colorScheme={colorScheme} toggleColorScheme={toggleColorScheme}>
   <MantineProvider
     theme={{
       colorScheme,
       fontFamily: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
       fontFamilyMonospace: "'DM Mono', 'Courier New', monospace",
       primaryColor: 'atoms',
       colors: {
         // ATOMS cyan — used as the primary colour for all Mantine components
         atoms: [
           '#E6F5FA', // 0 — accent-soft
           '#C0E6F3', // 1
           '#96D5EB', // 2
           '#65C2E1', // 3
           '#3AAFD6', // 4
           '#0897BE', // 5 — --accent (default button, active states)
           '#0780A3', // 6 — --accent-hover
           '#066080', // 7 — --accent-dark
           '#055F7E', // 8 — --accent-ink
           '#033D52', // 9
         ],
       },
       primaryShade: 5,
       defaultRadius: 'md',
       radius: { xs: 3, sm: 5, md: 7, lg: 10, xl: 14 },
       spacing: { xs: 8, sm: 12, md: 16, lg: 20, xl: 28 },
       shadows: {
         xs: '0 1px 2px rgba(12,14,22,0.05)',
         sm: '0 1px 4px rgba(12,14,22,0.07)',
         md: '0 2px 8px rgba(12,14,22,0.09), 0 0 0 1px rgba(12,14,22,0.04)',
         lg: '0 8px 24px rgba(12,14,22,0.11), 0 0 0 1px rgba(12,14,22,0.05)',
         xl: '0 8px 24px rgba(12,14,22,0.11), 0 0 0 1px rgba(12,14,22,0.05)',
       },
       headings: {
         fontFamily: "'DM Sans', sans-serif",
         fontWeight: 600,
       },
       other: {
         online:  '#00875A',
         offline: '#C42B1C',
         warn:    '#B45309',
       },
       components: {
         Modal: {
           defaultProps: {
             centered: true,
             zIndex: 400,
             overlayProps: { zIndex: 399 },
           },
         },
         Button: {
           styles: () => ({
             root: {
               fontFamily: "'DM Sans', sans-serif",
               fontWeight: 500,
               letterSpacing: '0.01em',
             },
           }),
         },
         TextInput: {
           styles: () => ({
             label: { fontFamily: "'DM Sans', sans-serif", fontWeight: 500, fontSize: 13, marginBottom: 5 },
             input: { fontFamily: "'DM Sans', sans-serif", fontSize: 13 },
           }),
         },
         Select: {
           styles: () => ({
             label: { fontFamily: "'DM Sans', sans-serif", fontWeight: 500, fontSize: 13, marginBottom: 5 },
             input: { fontFamily: "'DM Sans', sans-serif", fontSize: 13 },
             item:  { fontFamily: "'DM Sans', sans-serif", fontSize: 13 },
           }),
         },
         Tabs: {
           styles: () => ({
             tab: { fontFamily: "'DM Sans', sans-serif", fontWeight: 400, fontSize: 13 },
             tabLabel: { fontFamily: "'DM Sans', sans-serif" },
           }),
         },
         Badge: {
           styles: () => ({
             root: { fontFamily: "'DM Sans', sans-serif", fontWeight: 500, letterSpacing: '0.01em' },
           }),
         },
         Table: {
           styles: () => ({
             root: { fontFamily: "'DM Sans', sans-serif", fontSize: 13 },
           }),
         },
         Drawer: {
           defaultProps: { position: 'right', size: 'md' },
           styles: () => ({
             title: { fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: 15 },
             body:  { fontFamily: "'DM Sans', sans-serif" },
           }),
         },
         Stepper: {
           styles: (theme) => ({
             stepLabel: { fontFamily: "'DM Sans', sans-serif", fontWeight: 500, fontSize: 13 },
             stepDescription: { fontFamily: "'DM Sans', sans-serif", fontSize: 11 },
           }),
         },
       },
     }}
     withGlobalStyles
     withNormalizeCSS
   >
    <RecoilRoot>
    <Router>
            <Routes>
              <Route exact path='/about' element={<Home/>} />
              {/* <Route exact path='/login' element={window.localStorage.getItem('username') !== undefined  ? <Navigate to={'/app/dashboard'}/> : <LoginPage/>}/> */}
              <Route exact path='/login' element={ <LoginPage/>}/>
              {/* Main app routes — wrapped in AppShell via PrivateRoutes/MainLayout */}
              <Route exact path='/app' element={<PrivateRoutes/>}>
                  <Route exact path='dashboard'  element={ <DashBoardPage /> } />
                  <Route exact path='machine' element={ <MachinePage /> }/>
                  <Route exact path='trail' element={  <TrailPage /> } />
                  <Route exact path='report' element={ <ReportPage />} />
                  <Route exact path='submachine/:machine/:nodeid' element={ <SubMachine/>} />
              </Route>

              {/* Admin panel routes — NO AppShell wrapper so modals render correctly */}
              <Route path='/app' element={<AdminPrivateRoute/>}>
                  <Route exact path='admin-panel' element={ <AdminPanel /> } />
                  <Route exact path='super-admin' element={ <SuperAdminPanel /> } />
                  <Route exact path='machines/new' element={ <MachineEditPage /> } />
                  <Route exact path='machines/:machineId/edit' element={ <MachineEditPage /> } />
                  <Route exact path='users/new' element={ <UserEditPage /> } />
                  <Route exact path='users/:userId/edit' element={ <UserEditPage /> } />
              </Route>

              <Route exact path='/' element={ window.localStorage.getItem('token') ? <Navigate to={'/app/dashboard'}/> : <Navigate to='/login'/>} /> 
              
                <Route path='*' element={<PageNotFound404/>}/>  
                <Route path='/test' element={<PdfExport/>}/>
                <Route path='/alarm' element={<AlarmCard/>}/>
              </Routes>
           </Router>
    </RecoilRoot>
      </MantineProvider>
      </ColorSchemeProvider>
      
  );
}

export default App;

